<template>
  <div class="picturecard">
     <!-- :style="{ backgroundImage: 'url(' + content.background + ')' }" -->
    <div class="content">
      <div class="container">
        <Title :msg="content.title"></Title>
        <div class="row m-auto">
          <div class="col col-12 col-lg-4 col-md-6"
          v-for="(item, index) in content.cards" :key="index">
            <performanceCard
            :cards="item"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/title_nobg.vue';
import performanceCard from '@/components/performance_one.vue';

export default {
  props: {
    performance: {
      type: Object,
      default: () => ({
        title: '服務實績',
        // background: 'https://picsum.photos/600/300?random=30',
        cards: [
          {
            title: '露天農田',
            type: '農民服務',
            picture: 'https://picsum.photos/300/200?random=11',
          },
          {
            title: '露天農田',
            type: '農民服務',
            picture: 'https://picsum.photos/300/200?random=12',
          },
        ],
      }),
    },
  },
  data() {
    return {
      content: this.performance,
    };
  },
  components: {
    Title,
    performanceCard,
  },
};
</script>

<style scoped lang="scss">
.picturecard {
  // background-repeat: no-repeat;
  // background-size: cover;
  // background-attachment: fixed;
  .content {
    padding: 50px 0;
    text-align: center;
    background-color: #efeff0;
    // background: rgba(0, 0, 0, 0.5);
    // color: #fff;
    .row {
      margin: auto;
      padding: 15px;
    }
    .col {
      margin: 0;
      padding: 0;
      margin-bottom: 4px;
    }
  }
}

@media screen and (max-width: 600px){
  .picturecard {
    .content {
      .row {
        padding: 0;
      }
    }
  }
}
</style>
